import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueCountdown from '@chenfengyuan/vue-countdown';
import axios from 'axios'
import VueAxios from 'vue-axios'
import Toasted from 'vue-toasted'
import VueMeta from 'vue-meta'
import '../node_modules/timeline-vuejs/dist/timeline-vuejs.css'


Vue.component(VueCountdown.name, VueCountdown);
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(Toasted, {
  position: 'bottom-center',
  theme: 'bubble',
  type: 'success'
})
Vue.use(VueMeta)

// company
const Home = () => import('./components/Homepage.vue')
const contactInfo = () => import('./components/contactInfo.vue')
// clients
// const ArinaFerio = () => import('./components/ArinaFerio.vue')
// const RiaRian = () => import('./components/RiaRian.vue')
// const dbRestApi = () => import('./components/dbRestApi.vue')
// const MitaAjiV1 = () => import('./components/MitaAjiV1.vue')
// const MitaAjiV2 = () => import('./components/MitaAjiV2.vue')
// const TamiKiki = () => import('./components/TamiKiki.vue')
// const DellaJuan = () => import('./components/DellaJuan.vue')
// const ReslyErfan = () => import('./components/ReslyErfan.vue')
// const ErisaSyaiful = () => import('./components/ErisaSyaiful.vue')
// const PutriAndri = () => import('./components/PutriAndri.vue')
const DinaResha = () => import('./components/DinaResha.vue')
// const PelantikanPersagi = () => import('./components/PelantikanPersagi.vue')
const FatihahFatnan = () => import('./components/FatihahFatnan.vue')

// component
// const Music = () => import('./components/Music.vue')

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/',
      component: Home,
      meta: {
        title: 'Invity | Your Digital Invitation',
        metaTags: [
          {
            name: 'description',
            content: 'Invity | Your Digital Invitation'
          },
          {
            property: 'og:description',
            content: 'Invity | Your Digital Invitation'
          }
        ]
      }
    },
    {
      path: '/contact',
      component: contactInfo,
      meta: {
        title: 'Invity | Your Digital Invitation',
        metaTags: [
          {
            name: 'description',
            content: 'Invity | Your Digital Invitation'
          },
          {
            property: 'og:description',
            content: 'Invity | Your Digital Invitation'
          }
        ]
      }
    },
  //   { 
  //     path: '/ArinaFerio',
  //     component: ArinaFerio,
  //     meta: {
  //       title: 'Arina & Ferio - Tying The Knot',
  //       metaTags: [
  //         {
  //           name: 'description',
  //           content: 'Arina & Ferio - Tying The Knot'
  //         },
  //         {
  //           property: 'og:description',
  //           content: 'Arina & Ferio - Tying The Knot'
  //         }
  //       ]
  //     }
  //   },
  //   { 
  //     path: '/RiaRian',
  //     component: RiaRian,
  //     meta: {
  //       title: 'Ria & Rian - Tying The Knot',
  //       metaTags: [
  //         {
  //           name: 'description',
  //           content: 'Ria & Rian - Tying The Knot'
  //         },
  //         {
  //           property: 'og:description',
  //           content: 'Ria & Rian - Tying The Knot'
  //         }
  //       ]
  //     }
  //   },
  //   { 
  //     path: '/dbRestApi',
  //     component: dbRestApi,
  //     meta: {
  //       title: 'Ria & Rian - Tying The Knot',
  //       metaTags: [
  //         {
  //           name: 'description',
  //           content: 'Ria & Rian - Tying The Knot'
  //         },
  //         {
  //           property: 'og:description',
  //           content: 'Ria & Rian - Tying The Knot'
  //         }
  //       ]
  //     }
  //   },
  //   {
  //     path: '/MitaAji',
  //     component: MitaAjiV1,
  //     meta: {
  //       title: 'Irmita & Aji - Tying The Knot',
  //       metaTags: [
  //         {
  //           name: 'description',
  //           content: 'Irmita & Aji - Tying The Knot'
  //         },
  //         {
  //           property: 'og:description',
  //           content: 'Irmita & Aji - Tying The Knot'
  //         }
  //       ]
  //     }
  //   },
  //   { 
  //     path: '/AMazingStory',
  //     component: MitaAjiV2,
  //     meta: {
  //       title: 'Irmita & Aji - Tying The Knot',
  //       metaTags: [
  //         {
  //           name: 'description',
  //           content: 'Irmita & Aji - Tying The Knot'
  //         },
  //         {
  //           property: 'og:description',
  //           content: 'Irmita & Aji - Tying The Knot'
  //         }
  //       ]
  //     }
  //   },
  //   {
  //     path: '/TamiKiki',
  //     component: TamiKiki,
  //     meta: {
  //       title: 'Tami & Kiki - Tying The Knot',
  //       metaTags: [
  //         {
  //           name: 'description',
  //           content: 'Tami & Kiki - Tying The Knot'
  //         },
  //         {
  //           property: 'og:description',
  //           content: 'Tami & Kiki - Tying The Knot'
  //         }
  //       ]
  //     }
  //   },
  //   { 
  //   path: '/music-test',
  //   component: Music,
  //   meta: {
  //     title: 'Arina & Ferio - Tying The Knot',
  //     metaTags: [
  //       {
  //         name: 'description',
  //         content: 'Arina & Ferio - Tying The Knot'
  //       },
  //       {
  //         property: 'og:description',
  //         content: 'Arina & Ferio - Tying The Knot'
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: '/DellaJuanWedding',
  //   component: DellaJuan,
  //   meta: {
  //     title: 'Della & Juan - Tying The Knot',
  //     metaTags: [
  //       {
  //         name: 'description',
  //         content: 'Della & Juan - Tying The Knot'
  //       },
  //       {
  //         property: 'og:description',
  //         content: 'Della & Juan - Tying The Knot'
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: '/ReslyErfan',
  //   component: ReslyErfan,
  //   meta: {
  //     title: 'Resly & Erfan - Tying The Knot',
  //     metaTags: [
  //       {
  //         name: 'description',
  //         content: 'Resly & Erfan - Tying The Knot'
  //       },
  //       {
  //         property: 'og:description',
  //         content: 'Resly & Erfan - Tying The Knot'
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: '/ReslyErfanWedding',
  //   component: ReslyErfan,
  //   meta: {
  //     title: 'Resly & Erfan - Tying The Knot',
  //     metaTags: [
  //       {
  //         name: 'description',
  //         content: 'Resly & Erfan - Tying The Knot'
  //       },
  //       {
  //         property: 'og:description',
  //         content: 'Resly & Erfan - Tying The Knot'
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: '/ErisaSyaiful',
  //   component: ErisaSyaiful,
  //   meta: {
  //     title: 'Erisa & Syaiful - Tying The Knot',
  //     metaTags: [
  //       {
  //         name: 'description',
  //         content: 'Erisa & Syaiful - Tying The Knot'
  //       },
  //       {
  //         property: 'og:description',
  //         content: 'Erisa & Syaiful - Tying The Knot'
  //       }
  //     ]
  //   }
  // },
  // {
  //   path: '/PutriAndriWedding',
  //   component: PutriAndri,
  //   meta: {
  //     title: 'Putri & Andri - Tying The Knot',
  //     metaTags: [
  //       {
  //         name: 'description',
  //         content: 'Putri & Andri - Tying The Knot'
  //       },
  //       {
  //         property: 'og:description',
  //         content: 'Putri & Andri - Tying The Knot'
  //       }
  //     ]
  //   }
  // },
  {
    path: '/ExampleInvitation',
    component: DinaResha,
    meta: {
      title: 'Dina & Resha - We are engaged!',
      metaTags: [
        {
          name: 'description',
          content: 'Dina & Resha - We are engaged!'
        },
        {
          property: 'og:description',
          content: 'Dina & Resha - We are engaged!'
        }
      ]
    }
  },
  // {
  //   path: '/pelantikanPERSAGICjr2022',
  //   component: PelantikanPersagi,
  //   meta: {
  //     title: 'Pelantikan PERSAGI Cianjur 2022',
  //     metaTags: [
  //       {
  //         name: 'description',
  //         content: 'Pelantikan PERSAGI Cianjur 2022'
  //       },
  //       {
  //         property: 'og:description',
  //         content: 'Pelantikan PERSAGI Cianjur 2022'
  //       }
  //     ]
  //   }
  // }
  {
    path: '/FatihahFatnanWedding',
    component: FatihahFatnan,
    meta: {
      title: 'Fatihah Fatnan Tying the Knot',
      metaTags: [
        {
          name: 'description',
          content: 'Fatihah Fatnan Tying the Knot'
        },
        {
          property: 'og:description',
          content: 'Fatihah Fatnan Tying the Knot'
        }
      ]
    }
  }
  ]
})

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
